import { render, staticRenderFns } from "./TrackBullionHistory.vue?vue&type=template&id=2861be08&scoped=true&"
import script from "./TrackBullionHistory.vue?vue&type=script&lang=js&"
export * from "./TrackBullionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TrackBullionHistory.vue?vue&type=style&index=0&id=2861be08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861be08",
  null
  
)

export default component.exports